import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ToggleRow = styled.div`
  width: 100%;
  padding: ${Spacing.S16} 0;
`
